<template>
  <div>
    <title-banner :imgType="10" :isProductDetail="false"></title-banner>
    <div class="jiancerending">
      <div class="jianjie" v-html="info.jianceRenzheng"></div>
      <div class="zhengshulist">
        <div class="zhengshuItem" v-for="(item,index) in zhengshuList" :key="index" @click="openImg(item)">
          <img :src="'/boot'+item.picture" alt="">
          <div>{{ item.name }}</div>
        </div>
      </div>
    </div>

    <div class="preview-img" v-if="imgurl != ''">
      <div class="preview-img-">
        <div class="preview-img-bg"></div>
        <div class="preview-img-close" @click="imgurl = ''">×</div>
        <div class="preview-img-img" :style="'background-image: url('+imgurl+');'"></div>
      </div>
    </div>

  </div>
</template>

<script>
import titleBanner from "@/components/titleBanner/index.vue";
import { imgList,configList } from "@/utils/http";

export default {
  name: "authentication",
  components: {
    titleBanner
  },
  data() {
    return {
      zhengshuList:[],
      imgurl:'',
      info: {}
    };
  },
  created() {},

  mounted() {
    this.getConfigList()
    this.getBannerList()
  },
  methods:{
    async getConfigList(){
      const res = await configList();
      this.info = res.rows[0]
    },
    openImg(item){
      this.imgurl = '/boot'+item.picture
    },
    async getBannerList(){
      const res = await imgList(3);
      this.zhengshuList = res.rows
    },
  }
};
</script>

<style lang="scss" scoped>

.preview-img {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999
}

.preview-img .preview-img- {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center
}

.preview-img .preview-img-bg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0,0,0,.5);
  z-index: 2;
  cursor: pointer
}

.preview-img .preview-img-close {
  position: absolute;
  top: 5%;
  right: 12%;
  font-size: 50px;
  color: #c4c4c4;
  z-index: 10;
  cursor: pointer
}

.preview-img .preview-img-img {
  min-width: 70%;
  min-height: 80%;
  max-width: 70%;
  max-height: 80%;
  position: relative;
  z-index: 5;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat
}

.preview-img .preview-img-img img{
  max-width: 100%;
  max-height: 100%
}


.jiancerending{
  margin:0 auto;width: 1200px;
  padding: 40px 0;
}
.jianjie{
  font-weight: 400;
  font-size: 15px;
  color: #222222;
  margin-bottom: 20px;
}
.zhengshulist{
  display: flex;
  flex-wrap: wrap; /* 允许子元素换行 */
  justify-content: flex-start; /* 保持左对齐 */
  .zhengshuItem{
    width: 285px;
    background: #F7F7F7;
    text-align: center;
    margin-right: 20px;
    margin-bottom: 20px;
    padding: 40px 0 ;
    img{
      width: 194px;
      height: 268px;
      margin-bottom: 20px;
    }
    div{
      font-weight: 400;
      font-size: 15px;
      color: #222222;
    }
  }
  .zhengshuItem:nth-child(4n){
    margin-right: 0;
  }
}
</style>
